import { create } from 'zustand';

export interface TakePaymentStore {
  isOpen: boolean;
  contactName: string;
  contactId: number | undefined;
  paymentId: number | undefined;
  amount: number | undefined;
  paymentMethodId: number | undefined;
  setPaymentId: (paymentId: number) => void;
  setContactId: (contactId: number) => void;
  setContactName: (contactName: string) => void;
  setAmount: (amount: number) => void;
  setPaymentMethodId: (paymentMethodId: number) => void;
  open: () => void;
  close: () => void;
  clean: () => void;
}

const useTakePaymentStore = create<TakePaymentStore>((set) => ({
  isOpen: false,
  paymentId: undefined,
  contactName: '',
  contactId: undefined,
  amount: undefined,
  paymentMethodId: undefined,

  setAmount: (amount: number) => set({ amount }),
  setPaymentId: (paymentId: number) => set({ paymentId }),
  setContactId: (contactId: number) => set({ contactId }),
  setContactName: (contactName: string) => set({ contactName }),
  setPaymentMethodId: (paymentMethodId: number) => set({ paymentMethodId }),
  open: () => {
    set({ isOpen: true });
  },
  close: () => {
    set({ isOpen: false });
  },
  clean: () =>
    set({
      isOpen: false,
      contactId: undefined,
      contactName: '',
      paymentId: undefined,
      amount: undefined,
      paymentMethodId: undefined,
    }),
}));

export default useTakePaymentStore;
